import { Card, Layout, Text, Badge, Box } from '@shopify/polaris';

function Dashboard() {
  return (
    <Layout>
      <Layout.Section>
        <Card>
          <Box padding="400">
            <Text variant="headingMd" as="h2">
              TS Team Member - Shopify
            </Text>
            <Box paddingBlockStart="100">
              <Text variant="bodyMd" as="p">
                Welcome to the Team Member Showcase app for Shopify. Manage your team members,
                create stunning showcases, and display them on your storefront.
              </Text>
            </Box>
          </Box>
        </Card>
      </Layout.Section>

      <Layout.Section>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
          <Card>
            <Box padding="400">
              <Text variant="headingSm" as="h3">
                Team Members
              </Text>
              <Box paddingBlockStart="100">
                <Text variant="bodyMd" as="p">
                  Create and manage your team members with detailed profiles, social links, and skills.
                </Text>
              </Box>
              <Box paddingBlockStart="200">
                <Badge>Unlimited</Badge>
              </Box>
            </Box>
          </Card>

          <Card>
            <Box padding="400">
              <Text variant="headingSm" as="h3">
                Team Showcases
              </Text>
              <Box paddingBlockStart="100">
                <Text variant="bodyMd" as="p">
                  Design beautiful showcases with multiple layout options and customization.
                </Text>
              </Box>
              <Box paddingBlockStart="200">
                <Badge>All Layouts Free</Badge>
              </Box>
            </Box>
          </Card>

          <Card>
            <Box padding="400">
              <Text variant="headingSm" as="h3">
                Categories
              </Text>
              <Box paddingBlockStart="100">
                <Text variant="bodyMd" as="p">
                  Organize team members into categories with custom colors and icons.
                </Text>
              </Box>
              <Box paddingBlockStart="200">
                <Badge>Unlimited</Badge>
              </Box>
            </Box>
          </Card>
        </div>
      </Layout.Section>

      <Layout.Section>
        <Card>
          <Box padding="400">
            <Text variant="headingSm" as="h3">
              Quick Start Guide
            </Text>
            <Box paddingBlockStart="200">
              <ol style={{ paddingLeft: '20px', lineHeight: '2' }}>
                <li>
                  <Text variant="bodyMd" as="span">
                    Create your team members with their profiles and details
                  </Text>
                </li>
                <li>
                  <Text variant="bodyMd" as="span">
                    Organize them into categories (optional)
                  </Text>
                </li>
                <li>
                  <Text variant="bodyMd" as="span">
                    Create a team showcase template
                  </Text>
                </li>
                <li>
                  <Text variant="bodyMd" as="span">
                    Customize the layout, colors, and typography
                  </Text>
                </li>
                <li>
                  <Text variant="bodyMd" as="span">
                    Add the app block to your theme
                  </Text>
                </li>
              </ol>
            </Box>
          </Box>
        </Card>
      </Layout.Section>
    </Layout>
  );
}

export default Dashboard;
